import React from 'react';

import { TooltipProps as MUITooltipProps } from '@mui/material/Tooltip';

import { IconButton } from '../IconButton';
import { Icon, IconComponentProps } from '../Icon';
import { Tooltip } from '../Tooltip';

interface CopyButtonProps {
  valueToCopy: string;
  onClick?: () => void;
  onReject?: () => void;
  size?: IconComponentProps['size'];
  iconName?: IconComponentProps['name'];
  iconColor?: IconComponentProps['color'];
  tooltip?: { text: string; placement: MUITooltipProps['placement'] };
  disabled?: boolean;
  testId?: string;
}

export const CopyButton = ({
  valueToCopy,
  onClick,
  onReject,
  size = '24',
  iconName = 'copy_outline',
  iconColor = 'original.brand.primary',
  tooltip,
  disabled,
  testId = 'copy-button-test-id',
}: CopyButtonProps) => {
  const handleCopy =
    (value: string) => async (e: React.MouseEvent<HTMLElement, MouseEvent>) => {
      e.stopPropagation();

      if (disabled) return;

      try {
        await navigator.clipboard.writeText(value);
        onClick?.();
      } catch (error) {
        onReject?.();
      }
    };

  return (
    <Tooltip
      title={tooltip?.text}
      placement={tooltip?.placement}
      disabled={!tooltip}
    >
      <IconButton
        type="button"
        size="small"
        testId={testId}
        onClick={handleCopy(valueToCopy)}
      >
        <Icon name={iconName} color={iconColor} size={size} />
      </IconButton>
    </Tooltip>
  );
};
